"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm$formData;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return !_vm.formData ? _c("el-skeleton", {
    attrs: {
      rows: 6,
      animated: ""
    }
  }) : _c("el-form", {
    ref: "formData",
    staticClass: "demo-form modern-left-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-width": "160px",
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Name",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 2,
        maxRows: 6
      },
      name: "name",
      required: "",
      placeholder: "Name",
      maxlength: 250,
      minlength: 3,
      "show-word-limit": ""
    },
    on: {
      input: function ($event) {
        return _vm.createSlug(_vm.formData.name);
      }
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Brand",
      prop: "brandId"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "Select",
      name: "brandId",
      required: ""
    },
    model: {
      value: _vm.formData.brandId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "brandId", $$v);
      },
      expression: "formData.brandId"
    }
  }, _vm._l(_vm.brandsList, function (brand) {
    return _c("el-option", {
      key: brand.id,
      attrs: {
        label: brand.name,
        value: brand.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Category",
      prop: "categoryId"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      placeholder: "Select"
    },
    model: {
      value: _vm.selectedCategoryId,
      callback: function ($$v) {
        _vm.selectedCategoryId = $$v;
      },
      expression: "selectedCategoryId"
    }
  }, _vm._l(_vm.categoryList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), ((_vm$formData = _vm.formData) === null || _vm$formData === void 0 ? void 0 : _vm$formData.productType) === "simple" && _vm.formData.productsVariation.length ? [_c("el-form-item", {
    attrs: {
      label: "Price"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 11
    }
  }, [_c("div", {
    staticClass: "sub-title"
  }, [_vm._v(" Regular Price ")]), _c("el-input-number", {
    staticStyle: {
      width: "150px"
    },
    attrs: {
      name: "unitPrice",
      placeholder: "Regular rice",
      size: "mini",
      min: 0,
      precision: 2
    },
    model: {
      value: _vm.formData.productsVariation[0].unitPrice,
      callback: function ($$v) {
        _vm.$set(_vm.formData.productsVariation[0], "unitPrice", $$v);
      },
      expression: "formData.productsVariation[0].unitPrice"
    }
  }), _c("help-text", {
    attrs: {
      content: ""
    }
  })], 1), _c("el-col", {
    attrs: {
      span: 11
    }
  }, [_c("div", {
    staticClass: "sub-title"
  }, [_vm._v(" Sale Price ")]), _c("el-input-number", {
    staticStyle: {
      width: "150px"
    },
    attrs: {
      name: "salePrice",
      placeholder: "Sale rice",
      size: "mini",
      min: 0,
      max: _vm.formData.productsVariation[0].unitPrice && _vm.formData.productsVariation[0].unitPrice > 0 ? +_vm.formData.productsVariation[0].unitPrice : undefined,
      precision: 2
    },
    model: {
      value: _vm.formData.productsVariation[0].salePrice,
      callback: function ($$v) {
        _vm.$set(_vm.formData.productsVariation[0], "salePrice", $$v);
      },
      expression: "formData.productsVariation[0].salePrice"
    }
  }), _c("help-text", {
    attrs: {
      content: ""
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "SKU"
    }
  }, [_c("el-input", {
    attrs: {
      name: "sku",
      placeholder: "SKU",
      maxlength: 30,
      minlength: 3
    },
    model: {
      value: _vm.formData.productsVariation[0].sku,
      callback: function ($$v) {
        _vm.$set(_vm.formData.productsVariation[0], "sku", $$v);
      },
      expression: "formData.productsVariation[0].sku"
    }
  })], 1), _c("el-form-item", {
    staticClass: "half-width",
    attrs: {
      label: "Manage Stock"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.productsVariation[0].manageStock,
      callback: function ($$v) {
        _vm.$set(_vm.formData.productsVariation[0], "manageStock", $$v);
      },
      expression: "formData.productsVariation[0].manageStock"
    }
  }), _c("help-text", {
    attrs: {
      content: "Enable stock management at product level"
    }
  })], 1), !_vm.formData.productsVariation[0].manageStock ? _c("el-form-item", {
    staticClass: "half-width",
    attrs: {
      label: "Stock Status"
    }
  }, [_c("el-switch", {
    attrs: {
      size: "mini",
      "active-text": "In Stock",
      "inactive-text": "Out Of Stock",
      "active-value": "In Stock",
      "inactive-value": "Out Of Stock"
    },
    model: {
      value: _vm.formData.productsVariation[0].stockStatus,
      callback: function ($$v) {
        _vm.$set(_vm.formData.productsVariation[0], "stockStatus", $$v);
      },
      expression: "formData.productsVariation[0].stockStatus"
    }
  }), _c("help-text", {
    attrs: {
      content: "Enable stock management at product level"
    }
  })], 1) : _vm._e(), _vm.formData.productsVariation[0].manageStock ? _c("el-form-item", {
    staticClass: "half-width",
    attrs: {
      label: "Allow backorders?"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.productsVariation[0].allowBackOrder,
      callback: function ($$v) {
        _vm.$set(_vm.formData.productsVariation[0], "allowBackOrder", $$v);
      },
      expression: "formData.productsVariation[0].allowBackOrder"
    }
  }), _c("help-text", {
    attrs: {
      content: "If managing stock, this controls whether or not backorders are allowed. If enabled, stock quantity can go below 0"
    }
  })], 1) : _vm._e(), _vm.formData.productsVariation[0].manageStock ? _c("el-form-item", {
    staticClass: "half-width",
    attrs: {
      label: "Stock Quantity"
    }
  }, [_c("el-input-number", {
    attrs: {
      name: "stockQuantity",
      placeholder: "stockQuantity",
      type: "number",
      min: 0,
      "controls-position": "right",
      precision: 0
    },
    model: {
      value: _vm.formData.productsVariation[0].stockQuantity,
      callback: function ($$v) {
        _vm.$set(_vm.formData.productsVariation[0], "stockQuantity", $$v);
      },
      expression: "formData.productsVariation[0].stockQuantity"
    }
  })], 1) : _vm._e()] : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "Description",
      prop: "Description"
    }
  }, [_c("editor", {
    attrs: {
      "api-key": "no-api-key",
      init: {
        height: 400,
        plugins: ["lists link image paste help wordcount table code"],
        toolbar: "undo redo | formatselect | bold italic | table | code | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help"
      }
    },
    model: {
      value: _vm.formData.description,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "description", $$v);
      },
      expression: "formData.description"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Tax",
      prop: "taxId"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "Select",
      name: "taxId",
      required: ""
    },
    model: {
      value: _vm.formData.taxId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "taxId", $$v);
      },
      expression: "formData.taxId"
    }
  }, _vm._l(_vm.taxes, function (tax) {
    return _c("el-option", {
      key: tax.id,
      attrs: {
        label: tax.name,
        value: tax.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    staticClass: "half-width",
    attrs: {
      label: "HSN Code",
      prop: "hsnCode"
    }
  }, [_c("el-input", {
    attrs: {
      type: "number",
      name: "hsnCode",
      placeholder: "HSN Code"
    },
    model: {
      value: _vm.formData.hsnCode,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "hsnCode", $$v);
      },
      expression: "formData.hsnCode"
    }
  })], 1), _c("el-form-item", [_vm.isEdit ? _c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: function ($event) {
        return _vm.submitForm(true);
      }
    }
  }, [_vm._v(" Save & Exit ")]) : _vm._e(), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      loading: _vm.loading,
      type: "success"
    },
    on: {
      click: function ($event) {
        return _vm.submitForm(false);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;